import Vue from "vue";
import Vuetify from "vuetify/lib";
import VuetifyConfirm from "vuetify-confirm";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#435156",
        secondary: "#728186",
        redorange: "#F37121",
        violet: "#7F5290",
        blue: "#00BFDC",
      },
    },
  },
});

Vue.use(VuetifyConfirm, { vuetify });

export default vuetify;
